import { useEffect } from 'react';
import { useAlgoliaAppContext } from '../hooks/useAlgoliaAppContext';
import { useParams, useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_TYPE } from '../constants/searchParamKeys';
const canonicalUrl = document.querySelector('head link[rel="canonical"]');
const loc = window.location;
export const SEOCanonicalURL = () => {
    const { pagePath } = useAlgoliaAppContext();
    const { handle, medium } = useParams();
    const [searchParams] = useSearchParams();
    useEffect(() => {
        if (canonicalUrl === null)
            return;
        const type = searchParams.get(SEARCH_PARAM_KEY_TYPE);
        canonicalUrl.href = `${loc.origin}${loc.pathname}${type !== null ? `?${SEARCH_PARAM_KEY_TYPE}=${type}` : ''}`;
    }, [pagePath, handle, medium, searchParams]);
    return null;
};
